define('Consolidated.History.View',	[
  'custom_order_history.tpl',
  'CustomMyAccountData.Model',
  'Utils',
  'Backbone'
], function (
  template,
  CustomMyAccountDataModel,
  Utils,
  Backbone
) {
  'use strict';

  // @class Kodella.CustomMyAccountData.Main.View @extends Backbone.View
  return Backbone.View.extend({

    template: template,

    title: Utils.translate('Aggregated Purchase History'),
    // eslint-disable-next-line
    page_header: Utils.translate('Aggregated Purchase History'),

    getSelectedMenu: function () {
      return this.options.selected || 'consolidatedhistory';
    },
    getBreadcrumbPages: function () {
      return {
        text: this.title,
        href: '/' + this.options.url || 'consolidated'
      };
    },

    initialize: function (options) {
      var jsonresp = '';
      var self = this;

      self.trantype = options.trantype || 'consolidated';
      self.title = options.title || 'Aggregated Purchase History';
      self.model = new CustomMyAccountDataModel();
      self.loading = true;

      self.model.fetch({
        async: false,
        data: { trantype: self.trantype}
      }).done(function (result) {
        if(result && result.apiresp && result.apiresp.length > 0) {
          jsonresp = JSON.parse(result.apiresp);
          if (jsonresp && jsonresp.url) {
            self.url = jsonresp.url;
            self.loading = false;
            self.render();
          }
        }
      });

    },

    getContext: function getContext() {

      return {
        title: this.title,
        isReturn: false,
        url: this.url || false,
        loading: this.loading,
        errorMessage: this.errorMessage
      };
    }
  });
});
